"use client"

import { useTranslations } from "@/i18n"
import {
  FinanceDisclosureLevel,
  type FinanceSurfaceContext,
} from "@/features/finance/hooks/finance-context-rules"

/**
 * Says that the figures above are shares, not amounts.
 *
 * Without it a card reads "63" where it used to read "$1,200" and looks broken. The number is correct and the
 * mode is working, but nothing on screen says so — which is exactly the experience that made branch autonomy
 * feel like a bug rather than a feature every time it was switched on.
 *
 * Renders nothing when the reader may see the amounts, which is the common case: a branch's own treasurer,
 * and every workspace still on `FULL_PARISH`.
 *
 * One component rather than the line repeated per widget, so the wording is corrected in one place. It reads
 * the board's resolved context (`useFinanceSurfaceContext`) — never the payload, and never governance alone,
 * which would wrongly caption a branch treasurer's own figures.
 */
export function WidgetShareNote({ context }: { context?: FinanceSurfaceContext }) {
  const t = useTranslations("finance.overview")

  if (context?.disclosure !== FinanceDisclosureLevel.Shares) return null

  return <p className='text-muted-foreground text-xs'>{t("widgets.common.shareOfChurch")}</p>
}
